<template>
  <div ref="select" class="select">
    <button class="select__bar" type="button" @click="toggle">
      <div class="select__value">
        {{ selectedValue }}
      </div>
      <app-icon
        class="select__icon"
        :variant="isOpen ? 'dropdown' : 'dropup'"
      ></app-icon>
    </button>
    <div v-show="isOpen" class="select__options">
      <button
        v-for="option in options"
        :key="option.value"
        class="select__option"
        :class="{ 'select__option--selected': value === option.value }"
        type="button"
        @click="select(option)"
      >
        {{ option.text }}
      </button>
    </div>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon.vue'

export default {
  components: {
    AppIcon,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    selectedValue() {
      return this.options.find(o => o.value === this.value).text
    },
  },
  props: {
    options: {
      type: Array,
      defaut: () => [],
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  mounted() {
    window.addEventListener('click', event => {
      if (!this.$refs.select) return
      if (!this.$refs.select.contains(event.target)) this.close()
    })
  },
  methods: {
    close() {
      this.isOpen = false
    },
    open() {
      this.isOpen = true
    },
    select(option) {
      this.$emit('input', option.value)
      this.close()
    },
    toggle() {
      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.select {
  position: relative;

  &__bar {
    background: #fff;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    padding: 1rem;
    text-align: left;
    width: 100%;
  }

  &__icon {
    height: 16px;
    width: 16px;
  }

  &__option {
    background: #fff;
    border: none;
    cursor: pointer;
    min-width: 100%;
    padding: 0.5rem 1rem;
    text-align: left;

    &:hover {
      background: $colorBackground;
    }

    &--selected {
      background: $colorBackgroundDark;
    }
  }

  &__options {
    border-radius: 3px;
    box-shadow: 0 2px 3px #00000044;
    display: flex;
    flex-direction: column;
    max-height: 18rem;
    min-width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    position: absolute;
    top: calc(100% + 1px);
  }

  &__value {
    flex: 1;
  }
}
</style>
